<wk-icon-search-sprite-pds3 />
<wk-icon-close-sprite-pds3 />
<wk-icon-filled-more-sprite-pds3 />
<wk-icon-arrow-down-sprite-pds3 />
<wk-icon-funnel-sprite-pds3 />

@if (title() || toolbar().length) {
    <wk-data-table-toolbar [title]="title()" [toolbar]="toolbar()" />
}

@if (searchable() || selectable()) {
    <div class="wk-data-table__bar">
        @if (searchable()) {
            <wk-data-table-searchbar />
        }
        @if (selectable() && actions().length) {
            <wk-data-table-actionbar />
        }
    </div>
}

@if (virtual()) {
    <wk-data-table-virtual />
} @else {
    <wk-data-table-paging />
}

@if (editable()) {
    <div class="wk-data-table__actions">
        <button-field-pds3 type="primary">
            <button class="wk-data-table__header__action" type="button" (click)="saveDataTable()" [disabled]="!edited()">
                {{ "Settings.save" | wkTranslate }}
            </button>
        </button-field-pds3>
        <button-field-pds3 type="secondary">
            <button class="wk-data-table__header__action" type="button" (click)="cancelDataTable()">
                {{ "Settings.cancel" | wkTranslate }}
            </button>
        </button-field-pds3>
    </div>
}
